$(document).ready(function() {
    $('.packages-list .btn-enquire-now').click(function(e) {
        e.preventDefault();
        $('#TotemForm_GeneralEnquiryForm_ReadyBuiltHomeID').val($(this).data('package'));
        return false;
    });
});
